export default "__VITE_ASSET__DI_XV0Uf__"